<template>
    <form id="formUpdate">
        <input multiple="multiple" :accept="accept" v-show="false" ref="fileRef" type="file" @change="handleFileChange($event)">
    </form>
</template>

<script>
import axios from 'axios'
export default {
  name: 'FileUpload',
  props: {
    accept: {
      type: String
    },
    maxFileSize: {
      type: Number
    },
    isVideo: {
      type: Boolean
    }
  },
  data () {
    return {
      uploadUrl: sessionStorage.getItem('uploadUrl'),
      selectedFiles: null
    }
  },
  watch: {
    accept () {
      console.log(this.accept,'----------------------------')
      this.$refs.fileRef.accept = this.accept
    }
  },
  mounted () {
    this.uploadUrl = sessionStorage.getItem('uploadUrl')
    this.$refs.fileRef.accept = this.accept
  },

  updated () {
    console.log(this.accept)
    console.log(this.maxFileSize)
  },

  methods: {
    async handleFileChange (event) {
      this.selectedFiles = Array.from(event.target.files)
      const formData = new FormData()
      let flag = true
      this.selectedFiles.forEach((file, index) => {
        let i = file.name.lastIndexOf('.')
        let t = file.name.substr(i)
        if (this.accept.indexOf(t) === -1) {
          console.log(this.accept, '----', t)
          this.$message.error('The file type of the file named ' + file.name + ' is incorrect! ')
          flag = false
        }

        if (file.size > this.maxFileSize) {
          this.$message.error('The file type of the file named ' + file.name + ' is the file is too large! ')
          flag = false
        }

        if (this.isVideo) {
          formData.append(`video`, file)
        } else {
          formData.append(`images[${index}]`, file)
        }
      })

      if (!flag) {
        this.$emit('upload-success', '')
        this.resetFileInput()
        return
      }



      let url = ''

      if (this.isVideo) {
        url = '/tutor/api/videoUpload'
      } else {
        url = '/tutor/api/multiImgUpload'
      }

      await axios.post(this.uploadUrl + url, formData).then(res => {
        if (res.data.code === 200) {
          this.$emit('upload-success', res.data.data)
          this.resetFileInput()
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    resetFileInput () {
      this.selectedFiles = null
      this.$refs.fileRef.value = ''
    },
    // 上传代理
    uploadFile () {
      this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
    }
  }
}
</script>

<style scoped>
.file-upload {
    margin: 20px;
}

.message {
    margin-top: 10px;
    padding: 10px;
    border-radius: 4px;
}

.message.success {
    background-color: #dff0d8;
    color: #3c763d;
}

.message.error {
    background-color: #f2dede;
    color: #a94442;
}
</style>



// WEBPACK FOOTER //
// src/components/views/childrens/Fileupload.vue